import { selectBuildingConstructionInProgress } from "../../../../selectors/selectBuildingConstructionInProgress";
export var checkBuildingUpgradeIsConstructionInProgress = function (path) { return function (action, state$) {
    var constructionInProgress = selectBuildingConstructionInProgress(state$.value);
    if (constructionInProgress) {
        return path;
    }
    return undefined;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/checks/checkBuildingUpgradeIsConstructionInProgress.ts
// module id = 2076
// module chunks = 3